export default __webpack_public_path__ + "static/media/ajuda.27f216e7.png";